 const Everest={
  slug:"everest-base-camp",
  title: 'Everest Base Camp Trek',
  duration: '12 days',
  location: 'Lukla → Namche Bazaar → Everest Base Camp, Nepal',
  difficulty: 'Hard',
  priceRange: '$$$ (Adventure)',
  bestTime: 'March–May & September–November',
  description: 'A legendary Himalayan trek offering breathtaking mountain views, Sherpa culture, and the ultimate Everest Base Camp experience.',
  highlights: [
    'Flight to Lukla',
    'Namche Bazaar acclimatization',
    'Tengboche Monastery',
    'Kala Patthar sunrise view',
    'Everest Base Camp hike',
    'Sherpa villages and culture'
  ],
  highlight360Views: [
  { label: "Everest Base Camp", place: "Everest Base Camp, Nepal" },
  { label: "Kala Patthar", place: "Kala Patthar, Nepal" },
  { label: "Namche Bazaar", place: "Namche Bazaar, Nepal" },
  { label: "Tengboche Monastery", place: "Tengboche Monastery, Nepal" },
  { label: "Khumbu Glacier", place: "Khumbu Glacier, Nepal" }
],

  image: 'https://images.unsplash.com/photo-1589182373726-e4f658ab50f0?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8ZXZlcmVzdHxlbnwwfHwwfHx8MA%3D%3D',
  days: [
    {
      day: 1,
      title: 'Arrival in Kathmandu',
      activities: [
        'Arrival and hotel transfer',
        'Trek briefing',
        'Gear check'
      ],
      accommodation: 'Kathmandu hotel',
      meals: 'Dinner included'
    },
    {
      day: 2,
      title: 'Fly to Lukla & Trek to Phakding',
      activities: [
        'Scenic flight to Lukla',
        'Short trek to Phakding',
        'River valley walk'
      ],
      accommodation: 'Tea house',
      meals: 'All meals included'
    },
    {
      day: 3,
      title: 'Phakding to Namche Bazaar',
      activities: [
        'Cross suspension bridges',
        'Enter Sagarmatha National Park',
        'First Everest views'
      ],
      accommodation: 'Tea house',
      meals: 'All meals included'
    }
  ],
  inclusions: [
    'Domestic flights (Kathmandu–Lukla)',
    'Experienced trekking guide',
    'Accommodation in tea houses',
    'All meals during trek',
    'Permits and park fees'
  ],
  exclusions: [
    'International flights',
    'Personal trekking gear',
    'Travel insurance',
    'Tips for guides/porters'
  ],
  tips: [
    'Acclimatize properly',
    'Stay hydrated',
    'Train cardio beforehand',
    'Carry altitude medication'
  ],
  budget: {
    flights: '$800-1200',
    accommodation: '$15-40/night',
    food: '$25-40/day',
    activities: '$50-80/day',
    permits: '$60-100',
    total: '$1800-3000 per person'
  }
}
export default Everest;